import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, of, switchMap } from 'rxjs';
import { CourseType } from 'src/app/model/course-type';
import { HelperService } from 'src/app/service/helper.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
  providedIn: 'root'
})
export class CoursetypeDataService extends DefaultDataService<CourseType> {

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService, public helperService: HelperService) {
    super('CourseType', http, httpUrlGenerator);    
}
override getAll(): Observable<CourseType[]> {
  const url = this.urlProvider.getUrl(EndPoints.get_courseTypes, undefined, undefined);
  return this.http
      .get(
          url,
          (Headers = {
              ...this.urlProvider.baseGetOptions()
          })
      )
      .pipe(
          switchMap((res: any) => {
              return of(<CourseType[]>JSON.parse(res.body['courseTypes']));              
          })
      );
}

}
